<script>
    import app from "../stores/app";
    import A from "../lib/Router/A.svelte";
    import AppIcon from "./icons/AppIcon.svelte";
    import {createEventDispatcher} from 'svelte/internal';

    export let title = '';
    export let subtitle = '';
    export let controls = null;
    export let page = '';

    let viewBy = $app.viewBy;

    const dispatch = createEventDispatcher();

    const onControlClick = (control) => {
        dispatch(control.key);
    };

    $app.page = page;

    $: if (viewBy != $app.viewBy) {
        viewBy = $app.viewBy;
        dispatch("reload");
    }
</script>

<div class="page-header">
    <div class="page-header-wrapper">
        <h1>{ title }</h1>
        {#if subtitle}
            <h2>{ subtitle }</h2>
        {/if}
    </div>
    {#if controls}
        <div class="controls">
            {#each controls as control}
                {#if !control.hidden}
                <span class="control { control.class || '' }">
                    {#if control.link}
                        <A href="{ control.link }" class="btn btn-primary btn-normal" title="{ control.tip }">
                            {#if control.icon}
                                <AppIcon icon="{ control.icon }" strokeWidth="2"/>
                            {/if}
                            { control.name }
                        </A>
                    {:else}
                        <button class="btn btn-primary btn-normal" title="{ control.tip }"
                                on:click={ () => onControlClick(control) }>
                            {#if control.icon}
                                <AppIcon icon="{ control.icon }" strokeWidth="2"/>
                            {/if}
                            { control.name }
                        </button>
                    {/if}
                </span>
                {/if}
            {/each}
        </div>
    {/if}
</div>

<style>
    .page-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 3rem;
    }

    .page-header h1, .page-header h2 {
        font-weight: normal;
        color: #6a6c6f;
    }

    .page-header h1 {
        font-size: 1.6rem;
        margin-bottom: 0;
    }

    .page-header h2 {
        font-size: 1.1rem;
        margin-top: 5px;
    }

    /*.page-header-wrapper {*/

    /*}*/

    /*.controls {*/

    /*}*/

    .controls .control {
        margin-left: 5px;
    }
</style>